module.exports = __webpack_public_path__ + "static/media/icon_visualizar.e6f33383.svg";